import { AiQueryPanel } from '@/components/ai/AiQueryPanel'

const EXAMPLES = [
  'How many devices are online vs offline?',
  'Which devices have FAIL or WARN event log health?',
  'Summarise OneDrive and Teams health across the estate.',
  'Which devices need attention for security or hardware?',
  'Summarise patch compliance across the estate.',
  'List active alerts and which devices they affect.',
]

export function Assistant() {
  return (
    <div className="flex min-h-[calc(100vh-8rem)] w-full flex-col">
      <AiQueryPanel
        scope="general"
        title="Bekat Dash assistant"
        description="Ask natural-language questions about devices, event logs, Microsoft 365 health, security snapshots, patches, alerts, software, and ThreatDown coverage in your portal data."
        examples={EXAMPLES}
        className="flex min-h-0 flex-1 flex-col"
      />
    </div>
  )
}
